import { ArrowDown } from 'lucide-react'

interface ScrollDownProps {
	isBottomVisible: boolean
	showEmptyChat: boolean
	bottomOfChatRef: React.RefObject<HTMLDivElement>
}

export const ScrollDown: React.FC<ScrollDownProps> = ({
	isBottomVisible,
	showEmptyChat,
	bottomOfChatRef,
}) => {
	if (isBottomVisible || showEmptyChat) {
		return null
	}

	return (
		<div
			style={{
				position: 'absolute',
				bottom: '10rem',
				left: '50%',
				transform: 'translateX(-50%)',
			}}
		>
			<div
				className="cursor-pointer rounded-full bg-primary-400 p-2"
				onClick={() => {
					if (bottomOfChatRef.current) {
						bottomOfChatRef.current.scrollIntoView({ behavior: 'smooth' })
					}
				}}
			>
				<ArrowDown className="text-white" />
			</div>
		</div>
	)
}
